<template>
  <div class="row">
    <div class="col-12">
      <page-header />
      <div class="row">
        <div class="col-12 main-content">
          <data-table
            v-model="table"
            :get-page="getPage"
            :per-page="250"
            :selectable-rows="true"
          >
            <template v-slot:head(company)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.company"
                input-type="number"
              />
            </template>
            <template v-slot:head(descriptionId)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.descriptionId" />
            </template>
            <template v-slot:head(language)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.language" />
            </template>
            <template v-slot:head(description)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.description" />
            </template>
          </data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../../table/data-table';
import { NotificationMixin, ArticleMixin } from '../../../mixins';
import TableFilter from '../../table/table-filter';
import PageHeader from '../../structure/page-header';


export default {
  name: 'ArticleDescriptions',
  components: { PageHeader, DataTable, TableFilter },
  mixins: [NotificationMixin, ArticleMixin],
  data: function() {
    return {
      table: {
        selectedRow: null,
        rows: [],
        fields: [
          {key: 'company', label: this.$translate('company')},
          {key: 'descriptionId', label: this.$translate('designation_id')},
          {key: 'language', label: this.$translate('language')},
          {key: 'description', label: this.$translate('description')},
        ],
        filter: {
          company: null,
          descriptionId: null,
          language: null,
          description: null,
        },
      },
    };
  },
  methods: {
    async getPage(ctx) {
      try {
        const response = await this.articleService.getArticleDescriptions(ctx);
        return { totalCount: response.totalCount, data: response.data };
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>
